import {Component, Input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-button-icon',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './button-icon.component.html',
  styleUrl: './button-icon.component.scss'
})
export class ButtonIconComponent {
  @Input() icon: string = '';
  @Input() disabled: boolean = false;
}
